var utils = require( './utils' );

var sticky_header = ( function( $ ) {

	var $header,
		$content;

	var _init = function() {
		$header  = $( '#header' );
		$content = $( '#content' );

		maybe_stick_header();

		$( window ).smartresize( function() {
			maybe_stick_header();
		});

		$( window ).on( 'scroll', function() {
			maybe_stick_header();
		} );
	};

	var maybe_stick_header = function () {
		if ( $( 'html' ).hasClass( 'ocm-open' ) ) {
			stick_header();
			return;
		}

		if ( utils.viewport_size().width > 992 && $( window ).scrollTop() > 0 ) {
			stick_header();
		} else {
			unstick_header();
		}
	};

	var stick_header = function() {
		$header.addClass( 'sticky' );
		_offset_content( true );
	};

	var unstick_header = function(  ) {
		$header.removeClass( 'sticky' );
		_offset_content();
	};

	var _offset_content = function( offset ) {
		if ( offset ) {
			$content.css( 'padding-top', $header.outerHeight() + 'px' );
		} else {
			$content.css( 'padding-top', '0' );
		}
	};

	$( document ).ready( _init );

	return {
		stick_header : stick_header,
		unstick_header : unstick_header,
		maybe_stick_header : maybe_stick_header
	};

} )( jQuery );

module.exports = sticky_header;